import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/brands/brand-293.png")